module.exports = __webpack_public_path__ + "img/score_4.3e425a1c.png";